import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wc-autoplay-wrapper" }
const _hoisted_2 = {
  class: "splide__toggle wc-autoplay",
  type: "button"
}
const _hoisted_3 = { class: "splide__toggle__pause" }
const _hoisted_4 = { class: "splide__toggle__play" }

import { onMounted, useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { Splide, SplideTrack } from '@splidejs/vue-splide';
import type { Options } from '@splidejs/splide';
import WCWebAdsCarouselModern from '../WCWebAdsCarouselModern/WCWebAdsCarouselModern.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCAutoplayCarouselModern',
  setup(__props) {

const { t } = useI18n();

const primaryOptions: Options = {
  perPage: 1,
  arrows: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  rewind: true,
  preloadPages: 3,
  lazyLoad: 'nearby',
  gap: '0.2rem',
  type: 'loop',
  keyboard: 'global',
  pagination: true,
  paginationKeyboard: true,
  paginationDirection: 'ltr',
};

const secondaryOptions: Options = {
  type: 'slide',
  arrows: false,
  rewind: true,
  gap: '0.2rem',
  pagination: false,
  autoplay: true,
  fixedWidth: 1,
  fixedHeight: 1,
  focus: 'center',
  preloadPages: 3,
  lazyLoad: 'nearby',
  isNavigation: true,
  updateOnMove: true,
  pauseOnHover: false,
  pauseOnFocus: false,
};

const primaryRef = useTemplateRef<InstanceType<typeof Splide>>('primary');
const secondaryRef = useTemplateRef<InstanceType<typeof Splide>>('secondary');

onMounted(() => {
  const primary = primaryRef.value;
  const secondary = secondaryRef.value;

  if (!primary || !secondary || !secondary.splide) {
    return;
  }

  primary.sync(secondary.splide);

  const secondaryTrack = secondary.splide.Components.Elements.track;
  secondaryTrack.classList.add('d-none');
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(WCWebAdsCarouselModern, {
    class: "wc-web-ads wc-carousel--negate-container position-relative",
    isSlider: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Splide), {
        options: primaryOptions,
        ref: "primary"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 512),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createVNode(_unref(Splide), {
        options: secondaryOptions,
        class: "wc-splide m-auto rounded",
        ref: "secondary",
        "has-track": false
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SplideTrack), null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "pause",
                  "data-testid": "pauseButton",
                  "aria-label": _unref(t)('pauseAutoplay')
                }, null, 8, ["aria-label"])
              ]),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "play",
                  "data-testid": "playButton",
                  "aria-label": _unref(t)('startAutoplay')
                }, null, 8, ["aria-label"])
              ])
            ])
          ])
        ]),
        _: 3
      }, 512)
    ]),
    _: 3
  }))
}
}

})